export default [{
  path: '/conformidade-obras',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Conformidade de Obras Histórico',
      path: 'historico',
      component: () => import('@/views/conformidadeObras/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Conformidade de Obras' }
        ]
      }
    },
    {
      name: 'Conformidade de Obras Edit',
      path: 'edit',
      component: () => import('@/views/conformidadeObras/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Conformidade de Obras', path: '/conformidade-obras/historico' },
          { name: 'Criar Teste' }
        ]
      }
    }
  ]
}];
